import Shimmer from "components/ui/shimmer"
import { IS_JEWLR } from "helpers/application"
import { cn } from "styles/utils"

const WizardPricingLoading = () => {
  return (
    <div className="tablet:mt-0 mt-8">
      <Shimmer
        className={cn(
          "h-(--base-height) w-full rounded-sm",
          IS_JEWLR() && "tablet:h-(--tablet-height)"
        )}
        style={{
          "--base-height": IS_JEWLR() ? "58px" : "32px",
          "--tablet-height": "48px",
        }}
      />
    </div>
  )
}

export default WizardPricingLoading
